import { Link } from "react-router-dom";
import { Wheat, Instagram, MessageCircle, Phone, MapPin, ShoppingBag } from "lucide-react";
import { CONTACT, SHOPIER_URL } from "../lib/contact";

export default function Footer() {
  return (
    <footer
      className="mt-24 border-t"
      style={{ borderColor: "var(--em-border)", background: "var(--em-stone)" }}
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-10 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5">
            <span className="inline-flex items-center justify-center w-9 h-9 rounded-full" style={{ background: "var(--em-terracotta-light)", color: "var(--em-terracotta-hover)" }}>
              <Wheat size={18} strokeWidth={1.75} />
            </span>
            <span className="font-serif text-lg font-semibold">Ekşi Maya Gurmesi</span>
          </div>
          <p className="mt-4 max-w-md text-sm text-[color:var(--em-espresso-soft)] leading-relaxed">
            Geleneksel doğal maya kültürüyle, ekmeğin sanatını evlerin ve profesyonellerin
            mutfağına taşıyoruz. Eğitim, ustalık ve dürüst zanaat.
          </p>
        </div>

        <div>
          <div className="eyebrow mb-3">Keşfet</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/egitimler" className="hover:text-[color:var(--em-terracotta-hover)]" data-testid="footer-trainings">Eğitimler</Link></li>
            <li><Link to="/egitim-basvuru" className="hover:text-[color:var(--em-terracotta-hover)]" data-testid="footer-apply">Eğitim Başvurusu</Link></li>
            <li><a href={SHOPIER_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 hover:text-[color:var(--em-terracotta-hover)]" data-testid="footer-orders"><ShoppingBag size={14} /> Ekmek Siparişi</a></li>
            <li><Link to="/iletisim" className="hover:text-[color:var(--em-terracotta-hover)]" data-testid="footer-contact">İletişim</Link></li>
          </ul>
        </div>

        <div>
          <div className="eyebrow mb-3">İletişim</div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2"><MapPin size={16} className="mt-0.5" /><span>{CONTACT.locationLine1}, {CONTACT.locationLine2}</span></li>
            <li><a href={CONTACT.phoneHref} className="inline-flex items-center gap-2 hover:text-[color:var(--em-terracotta-hover)]" data-testid="footer-phone"><Phone size={16} /> {CONTACT.phoneDisplay}</a></li>
            <li><a href={CONTACT.whatsappHref} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 hover:text-[color:var(--em-terracotta-hover)]" data-testid="footer-whatsapp"><MessageCircle size={16} /> WhatsApp</a></li>
            <li><a href={CONTACT.instagramHref} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 hover:text-[color:var(--em-terracotta-hover)]" data-testid="footer-instagram"><Instagram size={16} /> {CONTACT.instagramHandle}</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t" style={{ borderColor: "var(--em-border)" }}>
        <div className="max-w-7xl mx-auto px-5 lg:px-10 py-5 pb-20 sm:pb-5 flex flex-col items-center sm:items-start gap-1.5 text-xs text-[color:var(--em-text-mute)]">
          <span className="font-semibold text-[color:var(--em-espresso-soft)]" data-testid="footer-brand-registered">
            Ekşi Maya Gurmesi<sup className="ml-0.5 text-[0.65em] font-normal">®</sup>
          </span>
          <span className="text-center sm:text-left max-w-3xl leading-relaxed" data-testid="footer-copyright">© Ekşi Maya Gurmesi. Sitede yer alan tüm görsel ve içerikler Ekşi Maya Gurmesi&apos;ne aittir. İzinsiz kopyalanamaz veya kullanılamaz.</span>
        </div>
      </div>
    </footer>
  );
}
